<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 42 42">
        <g>
            <path :fill="color" d="M21 38.182c-9.474 0-17.182-7.708-17.182-17.182 0-9.474 7.708-17.182 17.182-17.182 9.474 0 17.182 7.708 17.182 17.182 0 9.474-7.708 17.182-17.182 17.182zM21 0C9.42 0 0 9.42 0 21s9.42 21 21 21 21-9.42 21-21S32.58 0 21 0z"/>
            <path :fill="color" d="M21 8.91a2.549 2.549 0 0 0-2.545 2.546A2.548 2.548 0 0 0 21 14a2.548 2.548 0 0 0 2.545-2.544A2.549 2.549 0 0 0 21 8.909z"/>
            <path :fill="color" d="M21 17.818c-1.055 0-1.91.855-1.91 1.91v11.454a1.909 1.909 0 1 0 3.82 0V19.727c0-1.054-.855-1.909-1.91-1.909z"/>
        </g>
    </svg>
</template>

<script>
    export default {
        props: ['height', 'width', 'color']
    }
</script>
